import * as React from 'react'
import { CastingType, castingI18nCastingType } from '../../../../services/models/castings.service'
import { StoreProps, castingStoreCanRenderCastingTypeInput } from '../../../../services/stores/casting.store'
import ButtonGroupComponent from '../../../shared/button-group.component'

export default function CastingOfferedServiceCastingTypeComponent ({ store, data, data: { offeredService, castingType } }: StoreProps) {
  const setCastingType = React.useCallback((castingType: CastingType) => {
    store.setCastingType(castingType)
    store.nextFocus({ from: 'offered-service', closeOnMobile: true })
  }, [store])


  const castingTypes = React.useMemo(
    () => (['casting_one_shot', 'casting_recurring'] as const).map(value => ({ value, text: castingI18nCastingType(value), disabled: !offeredService?.[value] })),
    [offeredService]
  )

  if (!castingStoreCanRenderCastingTypeInput(data)) return null
  return <ButtonGroupComponent name="castingType" value={ castingType } onChange={ setCastingType } data={ castingTypes } itemByLine={ 2 } reemitOnClick />
}
